// extracted by mini-css-extract-plugin
module.exports = {"cardImg":"RelatedModels_cardImg__CzHI5","card":"RelatedModels_card__ZRlbH","cardText":"RelatedModels_cardText__g4ifS"};